module.exports = __webpack_public_path__ + "static/media/Logo.59c8e177.svg";